import React from "react";
import axios from "axios";
import config from "ASSESSMENT/config";
import { Base64 } from 'js-base64';

class AssessmentApiCall extends React.Component {
    
    static async makeAssessmentApiCall(type, info, url) {
        let apiResult = { success: false, APIResult: {}, expired: false };
        let formData = new FormData();
        formData.append(type, true);
        formData.append('data', Base64.encode(JSON.stringify(info)));
        await axios({
            method: "post",
            url: config.RootUrl + url,
            data: formData,
            headers: {
                Accept: "application/json",
                "Content-Type": "multipart/form-data"
            },
        }).then((response) => {
            let jsonResponse = response.data;
            if (jsonResponse.success == 'true') {
                apiResult.success = true;
                apiResult.APIResult = jsonResponse;
            }

        }).catch(err => console.log("Assessment error", err))

        return apiResult;
    }
}

export default AssessmentApiCall;